package com.appcreator.client.firebase.auth

import androidx.compose.runtime.Composable
import coil3.PlatformContext
import coil3.compose.LocalPlatformContext
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthLogoutAction
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth

class LogoutPerformer(val action: FirebaseAuthLogoutAction): Performer {
    @Composable
    override fun deferred(): Performer.Deferred {
        val context = LocalPlatformContext.current
        return object : Performer.Deferred {
            override suspend fun perform(envStore: EnvStore) {
                Firebase.auth.signOut()
                platformLogout(context)
                Container.sendEvent(LoginEvent(null, null, null))
            }
        }
    }
}

internal expect suspend fun platformLogout(context: PlatformContext)